import { render, staticRenderFns } from "./QuestionnaireStepBody.vue?vue&type=template&id=352b0eac&scoped=true&lang=pug"
import script from "./QuestionnaireStepBody.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireStepBody.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireStepBody.vue?vue&type=style&index=0&id=352b0eac&prod&lang=sass&scoped=true"
import style1 from "./QuestionnaireStepBody.vue?vue&type=style&index=1&id=352b0eac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b0eac",
  null
  
)

export default component.exports